<template>
  <SparkModal :model-value="show" @update:model-value="handleClose">
    <template #header> Add Filter </template>
    <template #default>
      <SparkInput v-model="filterName" label="Filter Name" name="filterName" class="w-full" />
    </template>

    <template #footer>
      <div class="flex justify-end gap-8">
        <SparkButton variant="outlined" @click="handleClose"> Cancel </SparkButton>
        <SparkButton variant="secondary" @click="handleAdd" :disabled="!filterName"> Add </SparkButton>
      </div>
    </template>
  </SparkModal>
</template>

<script>
import SparkModal from '@/components/SparkComponents/SparkModal.vue';
import SparkButton from '@/components/SparkComponents/SparkButton.vue';
import SparkInput from '@/components/SparkComponents/SparkInput.vue';

export default {
  name: 'AddFilterModal',

  components: {
    SparkModal,
    SparkButton,
    SparkInput,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      filterName: '',
    };
  },

  methods: {
    handleClose() {
      this.filterName = '';
      this.$emit('close');
    },

    handleAdd() {
      if (this.filterName) {
        this.$emit('add', this.filterName);
        this.handleClose();
      }
    },
  },
};
</script>
